const page = document.getElementById("shogun_page").innerText;
if (page) {
    let splitPages = page.split(',');
    if (splitPages.length > 1) {
        for (let i = 0; i < splitPages.length; i++) {
            if(document.body.classList.contains(splitPages[i])) {
                var container = document.querySelector(`.${splitPages[i]}`);
            }
        }
    } else {
        var container = document.querySelector(`.${splitPages}`);
    }

}

if(container) {
    document.querySelector('.js-drawer-open-cart').classList.add("show-cart");
    //document.getElementById("CartBubble").classList.add('show-btn');
    document.querySelector('.nav-cta.small-hide').style.display = 'none';

    container.querySelectorAll('a.rca-add-to-cart-submit').forEach((btn) => {
        btn.addEventListener('click', added);
    });
    setTimeout(() => {
        var closeBtn = container.querySelector(".upcart-header-close-button");
        if(closeBtn) {
            // observe upcart mini cart
            const cartpopUp = container.querySelector("#CartPopup");
            attrObserver.observe(cartpopUp, {attributes: true})
        }
    }, 2000)

    var count = parseInt(document.getElementById('CartBubble').innerText) || 0;

    function added(e) {
        let selector = '#'+e.target.id+'.shg-product-atc-success';
        if(document.querySelector(".upcart-header-text")) {
            waitForElm(selector).then((elm) => {
                let thenum = document.querySelector(".upcart-header-text").innerText.match(/\d+/)[0]
                document.getElementById('CartBubble').innerText = thenum;
            });
        } else {
            waitForElm(selector).then((elm) => {
                    count ++;
                    document.getElementById('CartBubble').innerText = count;
            });
        }
    }

    function updateCount() {
        setTimeout(() => {
            let thenum = document.querySelector(".upcart-header-text").innerText.match(/\d+/)[0]
            document.getElementById('CartBubble').innerText = thenum;
        }, 500)
    }

    function waitForElm(selector) {
        return new Promise(resolve => {
            if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
            }

            const observer = new MutationObserver(mutations => {
                if (document.querySelector(selector)) {
                    observer.disconnect();
                    resolve(document.querySelector(selector));
                }
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        });
    }
    const attrObserver = new MutationObserver((mutations) => {
        mutations.forEach(mu => {
          if (mu.type !== "attributes" && mu.attributeName !== "class") return;
          updateCount()
        });
    });
}